var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeRank3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "url(#paint0_linear)",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16459 8.15338C7.21482 7.81118 7.31057 7.51294 7.45184 7.25865C7.59626 7.00436 7.77363 6.79245 7.98397 6.62292C8.19745 6.4534 8.44075 6.32782 8.71388 6.2462C8.98701 6.16143 9.28054 6.11905 9.59448 6.11905C9.93353 6.11905 10.2349 6.16771 10.4986 6.26503C10.7623 6.35921 10.9852 6.48793 11.1673 6.65118C11.3494 6.81443 11.4875 7.00436 11.5817 7.22098C11.6759 7.43446 11.723 7.66049 11.723 7.89909C11.723 8.11571 11.701 8.30721 11.6571 8.4736C11.6131 8.63684 11.5472 8.77969 11.4593 8.90212C11.3745 9.02142 11.2678 9.12345 11.1391 9.20821C11.0135 9.28984 10.8691 9.35891 10.7058 9.41541C11.4656 9.68226 11.8454 10.2003 11.8454 10.9694C11.8454 11.3336 11.7795 11.6507 11.6476 11.9207C11.5158 12.1906 11.3384 12.4151 11.1155 12.5941C10.8958 12.773 10.6399 12.908 10.3479 12.999C10.056 13.0869 9.75145 13.1309 9.43437 13.1309C9.10787 13.1309 8.81748 13.0964 8.56319 13.0273C8.3089 12.9551 8.08286 12.8452 7.88508 12.6977C7.6873 12.547 7.51306 12.3555 7.36237 12.1231C7.21482 11.8908 7.0861 11.6146 6.97622 11.2943L7.62608 11.0306C7.79561 10.9647 7.95258 10.9474 8.09699 10.9788C8.2414 11.0102 8.345 11.0824 8.40779 11.1955C8.54906 11.456 8.69818 11.646 8.85515 11.7653C9.01526 11.8814 9.20206 11.9395 9.41553 11.9395C9.57878 11.9395 9.72006 11.9128 9.83935 11.8594C9.96179 11.8029 10.0622 11.7323 10.1407 11.6475C10.2224 11.5596 10.2836 11.4607 10.3244 11.3509C10.3652 11.241 10.3856 11.1295 10.3856 11.0165C10.3856 10.869 10.3746 10.7371 10.3526 10.6209C10.3338 10.5016 10.2773 10.3996 10.1831 10.3149C10.0889 10.2301 9.94609 10.1657 9.75459 10.1218C9.56622 10.0747 9.30252 10.0511 8.96346 10.0511V9.0434C9.24915 9.0434 9.47989 9.02142 9.6557 8.97747C9.8315 8.93352 9.9665 8.87387 10.0607 8.79852C10.158 8.72004 10.2224 8.62586 10.2538 8.51598C10.2851 8.4061 10.3008 8.28523 10.3008 8.15338C10.3008 7.88339 10.2349 7.67619 10.1031 7.53178C9.97435 7.38423 9.77656 7.31045 9.50972 7.31045C9.2931 7.31045 9.10944 7.36853 8.95875 7.48469C8.8112 7.5977 8.70917 7.73898 8.65266 7.90851C8.58673 8.08117 8.5004 8.19576 8.39366 8.25227C8.28692 8.30878 8.13466 8.32134 7.93688 8.28994L7.16459 8.15338Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 4.97607,
    y: 5.11902,
    width: 8.8692,
    height: 11.0118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.5,
    y1: 0,
    x2: 9.5,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C76401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#462A0D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeRank3);
export default __webpack_public_path__ + "static/media/badge-rank-3.b01d2212e66fc9cbc8ac320b0c9a9b91.svg";
export { ForwardRef as ReactComponent };